import { useMemo } from 'react';

import { useLocalStorageState } from '@hcs/local-storage-state';
import {
  ExperienceFlagIds,
  ExperienceFlagsDevtoolSliceState,
} from '@hcs/types';

type ExperienceFlagDevLocalStorageState = Partial<
  Record<ExperienceFlagIds, boolean>
>;

export const useExperienceFlagsDevLocalStorageState = () => {
  const { state: localStorageState, actions } =
    useLocalStorageState<ExperienceFlagDevLocalStorageState>('expflags');
  const results: {
    state: ExperienceFlagsDevtoolSliceState;
    actions: typeof actions;
  } = useMemo(() => {
    const state: ExperienceFlagsDevtoolSliceState = {};
    if (localStorageState) {
      Object.entries(localStorageState).forEach(
        ([experienceFlagIdStr, value]) => {
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
          const experienceFlagId = experienceFlagIdStr as ExperienceFlagIds;
          state[experienceFlagId] = {
            value: value === true,
          };
        },
      );
    }
    return {
      actions,
      state,
    };
  }, [localStorageState, actions]);
  return results;
};
